import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/NextGenESPPowerSuppliesHero-bg.webp";
import ArticleImg        from "../../asset/images/news/news-2.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .nge { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .nge-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
    
  }
  .nge-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right;
    display: block;
  }
  .nge-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .nge-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .nge-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px;
    max-width: 520px;
  }
  .nge-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .nge-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .nge-breadcrumb {
    width: 100%; padding: 40px 0 0 0;
  }
  .nge-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto;
    padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .nge-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none;
    display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .nge-bc-item:hover { color: #EB2019; }
  .nge-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .nge-bc-sep img { width: 24px; height: 24px; display: block; }
  .nge-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER WRAPPER ══ */
  .nge-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
  }

  /* ══ MAIN SECTION ══ */
  .nge-main-section { padding: 80px 0 120px 0; }
  .nge-main-row {
    display: flex; align-items: flex-start; gap: 89px;
  }

  /* ══ ARTICLE ══ */
  .nge-article { flex: 1; min-width: 0; }

  /* Meta bar */
  .nge-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .nge-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A;
    padding-right: 15px;
  }
  .nge-meta-item:last-child {
    border-right: none;
    padding-right: 0;
  }
  .nge-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  /* Article title */
  .nge-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  /* Article image */
  .nge-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  /* Body text */
  .nge-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .nge-article-body p {
    margin-bottom: 15px;
  }
  .nge-article-body p:last-child { margin-bottom: 0; }

  /* Section headings */
  .nge-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 5px 0 15px 0; line-height: 160%;
    display: block;
  }

  /* Bullet list */
  .nge-article-body ul {
    list-style: none;
    margin: 0 0 15px 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .nge-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .nge-article-body ul li::before {
    content: '•';
    color: #202020;
    font-size: 18px;
    line-height: 160%;
    flex-shrink: 0;
  }

  .nge-article-body strong { font-weight: 600; color: #202020; }

  .nge-red-link {
    color: #EB2019; text-decoration: underline;
  }
  .nge-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .nge-bottom-row {
    display: flex; align-items: center;
    justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7;
    flex-wrap: wrap; gap: 16px;
  }
  .nge-bottom-nav {
    display: flex; align-items: center; gap: 60px;
  }
  .nge-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .nge-nav-btn:hover { color: #EB2019; }
  .nge-nav-btn img { width: 40px; height: 40px; display: block; }

  .nge-share-icons {
    display: flex; align-items: center; gap: 20px;
  }
  .nge-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0;
    transition: opacity 0.15s;
  }
  .nge-share-icon:hover { opacity: 0.85; }
  .nge-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .nge-sidebar { flex: 0 0 475px; }

  .nge-sidebar-block { margin-bottom: 60px; }

  .nge-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }

  /* Recent posts */
  .nge-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .nge-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .nge-recent-item:hover .nge-recent-title { color: #EB2019; }
  .nge-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .nge-recent-body { flex: 1; min-width: 0; }
  .nge-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }

  /* Social icons */
  .nge-social-icons { display: flex; align-items: center; gap: 30px; }
  .nge-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .nge-social-icon:hover { opacity: 0.8; }
  .nge-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .nge-hero             { height: 350px; }
    .nge-hero-content     { padding: 0 32px; }
    .nge-hero-title       { font-size: 30px; }
    .nge-hero-divider     { width: 100%; max-width: 479px; }
    .nge-breadcrumb       { padding: 24px 0 0 0; }
    .nge-breadcrumb-inner { padding: 0 32px; }
    .nge-inner            { padding: 0 32px; }
    .nge-main-section     { padding: 48px 0 60px 0; }
    .nge-main-row         { flex-direction: column; gap: 48px; }
    .nge-sidebar          { flex: none; width: 100%; }
    .nge-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .nge-hero             { height: 360px; }
    .nge-hero-content     { padding: 0 16px; }
    .nge-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .nge-hero-divider     { width: 100%; }
    .nge-hero-subtitle    { font-size: 14px; }
    .nge-breadcrumb       { padding: 30px 0 0 0; }
    .nge-breadcrumb-inner { padding: 0 16px; }
    .nge-bc-item          { font-size: 14px; gap: 14px; }
    .nge-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .nge-bc-sep img       { width: 22px; height: 22px; }
    .nge-inner            { padding: 0 16px; }
    .nge-main-section     { padding: 30px 0 60px 0; }
    .nge-main-row         { flex-direction: column; gap:60px;}
    .nge-sidebar          { flex: none; width: 100%; }
    .nge-sidebar-title { font-size: 20px;}
    .nge-article-title    { font-size: 20px; margin-bottom: 15px; }
    .nge-article-body     { font-size: 14px; }
    .nge-meta-item        { font-size: 14px; }
    .nge-article-img      { margin: 30px 0 30px 0; height: 250px; }
    .nge-h2               { font-size: 16px; margin: 15px 0 15px 0; }
    .nge-nav-btn img      { width: 24px; height: 24px; }
    .nge-nav-btn          { font-size: 14px; }
    .nge-share-icon img   { width: 34px; height: 34px; }
    .nge-bottom-nav {     gap: 20px;}
  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-guide/",
  },
];


export default function NextGenESPPowerSupplies() {
  return (
    <div className="nge">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="nge-hero">
        <img className="nge-hero-bg" src={HeroBgImg} alt="Next-Gen ESP Power Supplies Hero" />
        <div className="nge-hero-overlay" />
        <div className="nge-hero-content">
          <h1 className="nge-hero-title">
            Next-Gen ESP Power Supplies: Upgrades &amp; Sustainability In Industrial Air Pollution Control
          </h1>
          <hr className="nge-hero-divider" />
          <p className="nge-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="nge-breadcrumb" aria-label="Breadcrumb">
        <div className="nge-breadcrumb-inner">
          <a href="/" className="nge-bc-item">Home</a>
          <span className="nge-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="nge-bc-item">News &amp; Updates</a>
          <span className="nge-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="nge-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="nge-main-section">
        <div className="nge-inner">
          <div className="nge-main-row">

            {/* ── ARTICLE ── */}
            <article className="nge-article">

              {/* Meta bar */}
              <div className="nge-meta-bar">
                <span className="nge-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="nge-meta-item"><img src={CalendarIcon} alt="date" /> July 17, 2025</span>
                <span className="nge-meta-item"><img src={ClockIconImg} alt="time" /> 6:23 am</span>
                <span className="nge-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="nge-article-title">
                Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control
              </h1>

              {/* Body */}
              <div className="nge-article-body">

                <p>How quickly industrial air pollution control is evolving these days? Evolution is significant, and sustainable solutions are on the rise. The planet is focusing on stricter environmental laws and regulations as well as advanced technology, and the global push for sustainability is changing industrial patterns and improving emissions monitoring. And at the hub of it all? What is it? EPS is responsible for capturing dust and pollutants before they reach the atmosphere.</p>

                <p>But have you ever wondered how these systems keep up with rising demands for a smarter and greener operation? The answer lies in next-generation <strong>ESP power supplies</strong> and innovative <strong>IGBT upgrades</strong>.</p>

                <p>Curious? Let's get started!</p>

                {/* Article image */}
                <img className="nge-article-img" src={ArticleImg} alt="Next-Gen ESP Power Supplies" />

                <span className="nge-h2">Why Do ESP Power Supplies Need a Next-Gen Boost?</span>

                <p>Traditional ESP power supplies cannot cope with rising industrial demands and stricter environmental compliance. Here's why industries worldwide are now investing in next-generation ESP power supplies, especially with IGBT upgrades:</p>

                <span className="nge-h2"> 1. Extensive Testing to Complete Global Safety Norms</span>

                <ul>
                  <li>Stable spark control</li>
                  <li>Reduced power consumption</li>
                  <li>Better particle charging efficiency</li>
                </ul>

                <p>This precision directly translates to improved dust collection efficiency, lower emissions, and reduced operational costs. For instance, companies like <strong>Ador India</strong> have been at the forefront of offering advanced ESP power supply solutions that integrate IGBT modules.</p>

                <span className="nge-h2"> 2. Sustainability: Lower Carbon Footprint and Green Manufacturing</span>

                <p>Reducing the amount of energy and resources required to regulate industrial air pollution is the main goal of sustainability. Next-gen ESP power supplies achieve this by:</p>

                <ul>
                  <li>Optimizing power usage during low dust load conditions</li>
                  <li>Reducing thermal stress on components</li>
                  <li>Lowering maintenance frequency and associated resource use</li>
                </ul>

                <p>It's interesting to know that <strong>battery formation systems in India</strong> are currently utilizing the same energy-efficient design concept, where reliable battery quality depends on controlled and effective power supply. By adopting similar high-efficiency power supply technologies, battery manufacturers also reduce energy consumption and environmental impact.</p>

                <span className="nge-h2"> 3. Digital Integration and Predictive Maintenance</span>

                <p>Industrial power systems are changing as a result of digitalization. Modern ESP power supplies are now built with integrated monitoring and communication features, allowing real-time diagnostics and remote control.</p>

                <p>Benefits include:</p>

                <ul>
                  <li>Early detection of abnormal voltage or current patterns</li>
                  <li>Predictive maintenance scheduling</li>
                  <li>Reduced unplanned downtime</li>
                </ul>

                <p>The digital revolution is a component of a larger trend in which industrial machinery becomes smart, allowing for proactive performance optimization and data-driven decision-making.</p>

                <span className="nge-h2"> 4. Flexible Power Configurations: Tailored to Industrial Needs</span>

                <p>Different industries, from cement and steel to thermal power and chemicals, have varied particulate profiles and operational constraints. Next-generation ESP power supplies allow flexible configurations, such as:</p>

                <ul>
                  <li>Single-phase or three-phase systems</li>
                  <li>High-frequency or conventional designs</li>
                  <li>Modular power cabinets for scalable capacity</li>
                </ul>

                <p>Such flexibility is echoed in the design of <strong>battery formation systems in India</strong>, where modular power electronics can support production scaling or changes in battery chemistries without major redesigns.</p>

                <span className="nge-h2"> 5. Enhanced Safety and Compliance</span>

                <p>Lastly, modern ESP power supplies with IGBT technology offer improved safety. With better spark control, temperature monitoring, and fault detection, risks of electrical arcs and fires are minimized. This is crucial in industries handling flammable dust or operating in harsh conditions.</p>

                <p>Upgraded systems also simplify compliance reporting by generating detailed logs of power consumption and performance metrics, making audits smoother and more transparent.</p>

                <span className="nge-h2">In Essence</span>

                <p>To put it briefly, switching to an ESP power supply with IGBT technology is an essential step for more intelligent and environmentally friendly industrial operations. These next-generation systems boost efficiency, cut carbon footprints, and make predictive maintenance a breeze.</p>

                <p>With decades of experience, <strong>Ador Powertron</strong> is designing battery formation systems and ESP power supplies that are dependable, effective, and digitally integrated for India's challenging industrial environment. Whether you are planning an IGBT upgrade or designing a new plant, our team can help you achieve your environmental and operational goals.</p>

                <p><a href="/contact" className="nge-red-link">Contact us</a> now!</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="nge-bottom-row">
                <div className="nge-bottom-nav">
                  <a href="/news/green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/" className="nge-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/" className="nge-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="nge-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/" className="nge-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fnext-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control%2F&mode=login" className="nge-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fnext-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control%2F%26title%3DNext-Gen%2520ESP%2520Power%2520Supplies%2520for%2520Cleaner%2520Industries%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fnext-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control%2F" className="nge-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="nge-sidebar">

              {/* Recent Posts */}
              <div className="nge-sidebar-block">
                <p className="nge-sidebar-title">Recent Posts</p>
                <div className="nge-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="nge-recent-item">
                      <img src={post.img} alt={post.title} className="nge-recent-img" />
                      <div className="nge-recent-body">
                        <span className="nge-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="nge-sidebar-block">
                <p className="nge-sidebar-title">Social Media</p>
                <div className="nge-social-icons">
                  <a href="https://adorpowertron.com/news/7/" className="nge-social-icon" target="blank" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F"  target="blank" className="nge-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}